import apiCompetition from '@/api/competition'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: 0,
}

export const mutationTypes = {
  getCompetitionsTrainersListStart:
    '[competition trainers list] Get competitions trainers start',
  getCompetitionsTrainersListSuccess:
    '[competition trainers list] Get competitions trainers success',
  getCompetitionsTrainersListFailure:
    '[competition trainers list] Get competitions trainers failure',
}

export const actionTypes = {
  getCompetitionsTrainersList:
    '[competition trainers list] Get competition trainers list',
}

const mutations = {
  [mutationTypes.getCompetitionsTrainersListStart](state) {
    state.isLoading = true
    state.error = null
  },

  [mutationTypes.getCompetitionsTrainersListSuccess](state, payload) {
    state.total = payload.total
    state.data = payload.data ? payload.data : payload.list
    state.isLoading = false
  },

  [mutationTypes.getCompetitionsTrainersListFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getCompetitionsTrainersList](context, params) {
    context.commit(mutationTypes.getCompetitionsTrainersListStart)
    return new Promise((resolve) => {
      apiCompetition
        .getCompetitionTrainersList(params)
        .then((response) => {
          context.commit(mutationTypes.getCompetitionsTrainersListSuccess, {
            ...response.data,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(
            mutationTypes.getCompetitionsTrainersListFailure,
            error
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
